import React from 'react';
import { Facebook, Instagram, Linkedin, MapPin, Mail, Phone } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gray-900 text-gray-300 py-12 border-t border-gray-800" data-id="element-235">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-236">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12" data-id="element-237">
          {/* Company Info */}
          <div data-id="element-238">
            <h3 className="text-white text-lg font-bold mb-4" data-id="element-239">
              Desert Sage Seminars
            </h3>
            <div className="space-y-3 text-sm" data-id="element-240">
              <p className="flex items-start" data-id="element-241">
                <MapPin className="w-5 h-5 mr-3 text-brand-purple-400 flex-shrink-0" data-id="element-242" />
                <span data-id="element-243">Phoenix, Arizona</span>
              </p>
              <p className="flex items-center" data-id="element-244">
                <Phone className="w-5 h-5 mr-3 text-brand-purple-400 flex-shrink-0" data-id="element-245" />
                <a href="tel:6023776207" className="hover:text-white" data-id="element-246">
                  602-377-6207
                </a>
              </p>
              <p className="flex items-center" data-id="element-247">
                <Mail className="w-5 h-5 mr-3 text-brand-purple-400 flex-shrink-0" data-id="element-248" />
                <a href="mailto:CustomerService@DesertSageSeminars.com" className="hover:text-white" data-id="element-249">
                  CustomerService@DesertSageSeminars.com
                </a>
              </p>
            </div>
            <div className="mt-6 flex space-x-4" data-id="element-250">
              <a href="https://www.facebook.com/DesertSageSeminars/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" aria-label="Facebook" data-id="element-251">
                <Facebook className="w-5 h-5" data-id="element-252" />
              </a>
              <a href="https://instagram.com/desertsageseminars/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" aria-label="Instagram" data-id="element-253">
                <Instagram className="w-5 h-5" data-id="element-254" />
              </a>
              <a href="https://www.linkedin.com/company/desert-sage-seminars" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" aria-label="LinkedIn" data-id="element-255">
                <Linkedin className="w-5 h-5" data-id="element-256" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-257">
            <h3 className="text-white text-lg font-bold mb-4" data-id="element-258">Quick Links</h3>
            <ul className="space-y-2 text-sm" data-id="element-259">
              <li data-id="element-260">
                <a href="#" className="hover:text-brand-purple-400 transition-colors" data-id="element-261">
                  On-Demand Classes
                </a>
              </li>
              <li data-id="element-262">
                <a href="#" className="hover:text-brand-purple-400 transition-colors" data-id="element-263">
                  Zoom Classes
                </a>
              </li>
              <li data-id="element-264">
                <a href="#" className="hover:text-brand-purple-400 transition-colors" data-id="element-265">
                  In-Person Classes
                </a>
              </li>
              <li data-id="element-266">
                <a href="#" className="hover:text-brand-purple-400 transition-colors" data-id="element-267">
                  Class Schedule
                </a>
              </li>
              <li data-id="element-268">
                <a href="#" className="hover:text-brand-purple-400 transition-colors" data-id="element-269">
                  My Account
                </a>
              </li>
              <li data-id="element-270">
                <a href="#" className="hover:text-brand-purple-400 transition-colors" data-id="element-271">
                  Contact Support
                </a>
              </li>
            </ul>
          </div>

          {/* Certifications */}
          <div data-id="element-272">
            <h3 className="text-white text-lg font-bold mb-4" data-id="element-273">Accreditation</h3>
            <div className="space-y-4 text-sm" data-id="element-274">
              <div className="p-4 bg-gray-800 rounded-lg border border-gray-700" data-id="element-275">
                <p className="font-semibold text-white mb-1" data-id="element-276">
                  ADRE School #S06-0002
                </p>
                <p className="text-xs text-gray-400" data-id="element-277">
                  Approved by the Arizona Department of Real Estate
                </p>
              </div>
              <div className="p-4 bg-gray-800 rounded-lg border border-gray-700" data-id="element-278">
                <p className="font-semibold text-white mb-1" data-id="element-279">REEA Member</p>
                <p className="text-xs text-gray-400" data-id="element-280">
                  Real Estate Educators Association
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center text-sm text-gray-500" data-id="element-281">
          <p data-id="element-282">
            &copy; {new Date().getFullYear()} Desert Sage Seminars. All rights
            reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-283">
            <a href="/PrivacyStatement" className="hover:text-white" data-id="element-284">
              Privacy Policy
            </a>
            <a href="/PrivacyStatement#terms" className="hover:text-white" data-id="element-285">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}